export default class LogoAnimation {
  constructor(el) {
    this.DOM = {}
    this.DOM.$el = el

    this.fps = this.DOM.$el.fps
    this.logoShift = 0
    this.shift = this.DOM.$el.shift

    this.init()
  }

  init() {
    this.cacheSelectors()
    this.logoAnimStep()
  }

  cacheSelectors() {
    this.DOM.$logo = this.DOM.$el.container
  }

  logoAnimStep() {
    const self = this

    self.DOM.$logo.css('opacity', '1')

    setTimeout(() => {
      self.logoShift += self.DOM.$el.height
      if (self.logoShift >= self.shift) {
        return
      }
      self.DOM.$logo.css('background-position', `0px -${self.logoShift}px`)
      self.logoAnimStep()
    }, self.fps)
  }
}
